<img [src]="data" (click)="close()" />
